import { MoneyValue } from '../../generated/graphql'

export const MOCK_PRODUCTS = (currency?: string) => {
  return [
    {
      sku: 11447791,
      title: 'Testofen® Capsules',
      options: [
        {
          key: '',
          choices: [
            {
              title: '',
              optionKey: '',
              key: '',
            },
          ],
        },
      ],
      url: '/sports-nutrition/testofen-capsules/11447791.html',
      reviews: {
        total: 2,
        averageScore: 3.5,
        maxScore: 4,
        count1Score: 0,
        count2Score: 0,
        count3Score: 1,
        count4Score: 1,
        count5Score: 0,
        __typename: 'ProductReviews',
      },
      images: [
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/11447791-2054601701102809.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/11447791-2054601701102809.jpg',
          zoom:
            'https://s1.thcdn.com/productimg/960/960/11447791-2054601701102809.jpg',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          availabilityMessage: 'available',
          content: [
            {
              key: 'material',
              value: {
                __typename: 'ProductContentStringValue',
                value: '',
              },
            },
          ],
          sku: 11447791,
          title: 'Testofen® Capsules variant',
          inStock: true,
          images: [
            {
              __typename: 'ProductImage',
            },
          ],
          choices: [
            {
              optionKey: 'optionKey',
              key: 'choiceKey',
              colour: 'blue',
              title: 'choiceTitle',
            },
          ],
          price: {
            price: {
              displayValue: `£7.99`,
              amount: '7.99',
              currency: `${currency || 'GBP'}`,
              scalarValue: `${currency || 'GBP'}7.99`,
            } as MoneyValue,
            rrp: {
              displayValue: `£45.99`,
              amount: '45.99',
              currency: `${currency || 'GBP'}`,
              scalarValue: `${currency || 'GBP'}45.99`,
            } as MoneyValue,
            __typename: 'ProductPrice' as 'ProductPrice',
          },
          gbpPrice: {
            price: {
              displayValue: '£7.99',
              amount: '7.99',
              currency: `${currency || 'GBP'}`,
              scalarValue: `${currency || 'GBP'}7.99`,
            } as MoneyValue,
            rrp: {
              displayValue: '£45.99',
              amount: '45.99',
              currency: `${currency || 'GBP'}`,
              scalarValue: `${currency || 'GBP'}45.99`,
            } as MoneyValue,
            __typename: 'ProductPrice' as 'ProductPrice',
          },

          __typename: 'ProductVariant',
        },
      ],
      __typename: 'Product',
    },
  ]
}
